import { useGoogleMap } from '@ubilabs/google-maps-react-hooks';
import { useEffect } from 'react';

import { useClinics } from '../../hooks/useClinics';
import { useLocatorStore } from '../../store/useLocatorStore';
import { haversine, calculateBoundsWithRadius } from '../../utils/helpers';

export function useHandleBounds() {
  const { clinics } = useClinics();
  const {
    radius,
    radiusUnit,
    mapViewBounds,
    currentLocation,
    setVisibleClinics,
    setIsUserZooming,
  } = useLocatorStore((state) => state);

  const map = useGoogleMap();

  useEffect(() => {
    if (map && mapViewBounds && currentLocation && radius !== undefined) {
      const radiusInMetres = radius * (radiusUnit === 'km' ? 1000 : 1609.34);

      let newBounds = mapViewBounds;

      // If no radius is provided, fit the bounds directly
      if (radiusInMetres === 0) {
        setIsUserZooming(false);
        map?.fitBounds(newBounds);
        setTimeout(() => {
          setIsUserZooming(true);
        }, 500);
      } else {
        const swCorner = mapViewBounds.getSouthWest()!;
        const neCorner = mapViewBounds.getNorthEast()!;

        const centerLat = (swCorner.lat() + neCorner.lat()) / 2;
        const centerLng = (swCorner.lng() + neCorner.lng()) / 2;

        const maxDistance = haversine(centerLat, centerLng, swCorner.lat(), swCorner.lng());

        const maxDistancePlusRadius = maxDistance + radiusInMetres;

        // Calculate new bounds including the radius
        newBounds = calculateBoundsWithRadius(centerLat, centerLng, maxDistancePlusRadius);
      }

      const visibleClinics = clinics.filter((clinic) => {
        const clinicPosition = {
          lat: clinic.Geolocation__c.latitude,
          lng: clinic.Geolocation__c.longitude,
        };

        return newBounds.contains(clinicPosition);
      });

      setVisibleClinics(visibleClinics);

      setIsUserZooming(false);

      map?.fitBounds(newBounds);

      setTimeout(() => {
        setIsUserZooming(true);
      }, 1500);

      // Set the map bounds to the new bounds
    }
  }, [map, radius, mapViewBounds, currentLocation, radiusUnit]);

  useEffect(() => {}, []);
}
